import { config, useTransition } from '@react-spring/web';

export function useFade<T>(
  item: T,
  property: 'backgroundColor' | 'color' | 'opacity',
  from: string | number,
  to: string | number
) {
  return useTransition(item, {
    from: { [property]: from },
    enter: { [property]: to },
    leave: { [property]: from },
    config: config.default
  });
}
